<template>
  <v-dialog v-model="value" max-width="600px" persistent>
    <v-form @submit.prevent="onSubmit" ref="form" v-model="valid">
      <v-card>
        <v-card-title
          ><span class="headline font-weight-thin">{{ user.displayName }}</span>
        </v-card-title>
        <v-card-subtitle class="mb-0 pb-0"
          >User Principal Name (Username for login): {{ user.userPrincipalName }}</v-card-subtitle
        >
        <v-card-subtitle class="mt-0 pt-0">Entra ID: {{ user.username }}</v-card-subtitle>

        <v-card-text>
          <v-container grid-list-md>
            <v-row no-gutters>
              <v-col sm="12"> <v-checkbox label="Active" v-model="user.active"></v-checkbox> </v-col>
              <v-col sm="12">
                <v-select
                  :items="roleOptionList"
                  data-cy="roleOptionList"
                  item-text="label"
                  item-value="name"
                  label="Role"
                  v-model="user.role"
                ></v-select>
              </v-col>
              <v-col sm="12">
                <v-text-field-simplemask
                  data-cy="phoneNumber"
                  inputMask="SimpleMask"
                  :properties="{
                    clearable: true,
                    placeholder: '',
                    rules: [value => !value || value.length === 13 || 'Phone number must be 10 digits.'], // set to 13 to account for the masking,
                  }"
                  :options="{
                    inputMask: '(###)###-####',
                    outputMask: '##########',
                    empty: null,
                    applyAfter: false,
                    alphanumeric: true,
                  }"
                  v-model="user.phone"
                  label="Phone #"
                ></v-text-field-simplemask>
                <v-text-field :rules="emailRules" data-cy="email" label="Email" v-model="user.email"></v-text-field>
                <v-text-field
                  :rules="firstNameRules"
                  data-cy="firstName"
                  label="First Name"
                  v-model="user.firstName"
                ></v-text-field>
                <v-text-field
                  :rules="lastNameRules"
                  data-cy="lastName"
                  label="Last Name"
                  v-model="user.lastName"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close" outlined>Cancel</v-btn>
          <v-btn @click="save" :disabled="disableSubmit" data-cy="saveButton" color="primary">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  async created() {
    try {
      await this.fetchRoleList();
    } catch (e) {
      console.error(e);
      this.$notifyError({ message: "Error fetching list of Continuum roles" });
    }
  },
  computed: {
    disableSubmit() {
      return !this.valid;
    },
    ...mapState({
      user: state => state.admin.user.edit,
      roleOptionList: state => state.admin.role.list,
    }),
  },
  data() {
    return {
      emailRules: [
        v => !!v || "Email is required",
        v =>
          !v ||
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) ||
          "Email must be valid",
      ],
      firstNameRules: [v => !!v || "First name is required"],
      lastNameRules: [v => !!v || "Last name is required"],
      valid: false,
    };
  },
  methods: {
    close() {
      this.setUser({});
      this.$emit("input", false);
    },
    async save() {
      // PRIMARY OPERATION - must succeed to close modal
      try {
        await this.updateUser(this.user);
        this.$notifySuccess({ message: "User updated successfully" });
      } catch (e) {
        console.error(e);
        this.$notifyError({ message: `Error updating user ${this.user.username}`, timeout: 0 });
        return; // Early return keeps modal open
      }

      // Modal closes immediately after primary success
      this.close();

      // SECONDARY OPERATION - fail gracefully
      try {
        // Use the page's selected service area from route params, not the edited user's serviceAreaId
        const pageServiceAreaId = parseInt(this.$route.query.serviceArea, 10);
        await this.fetchUserList([
          {
            comparator: "=",
            name: "serviceAreaId",
            value: pageServiceAreaId,
          },
        ]);
      } catch (e) {
        console.error(e);
        this.$notifyError({ message: "Error refreshing list of Continuum users" });
      }
    },
    ...mapActions({
      fetchRoleList: "admin/role/fetchList",
      fetchUserList: "admin/user/fetchList",
      updateUser: "admin/user/update",
    }),
    ...mapMutations({
      setUser: "admin/user/setEdit",
    }),
  },
  props: ["value"],
};
</script>
